import styled from 'styled-components';

export const AccountCardWrapper = styled.div`
  flex: 0 0 calc(100% / 3 - 0.8125rem);
  min-width: 0;
`;

export const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  min-height: 75vh;
  width: 80vw;
  padding: 1%;
  border-radius: 0.625rem;
  position: relative;
`;

export const Carousel = styled.div`
  position: relative;
  width: 90%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
`;

export const ButtonRight = styled.button`
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  z-index: 2;
  background: transparent;
  border: none;
  color: var(--accent-secondary);
  font-size: 3.125rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
`;

export const ButtonLeft = styled.button`
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
  z-index: 2;
  background: transparent;
  border: none;
  color: var(--accent-secondary);
  font-size: 3.125rem; 
  cursor: pointer;
  padding: 0.25rem 0.5rem;
`;

export const CarouselContent = styled.div`
  display: flex;
  transition: transform 0.3s ease-in-out;
  gap: 0.8125rem;
  padding: 0.75rem;
  width: 100%;
  box-sizing: border-box;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  gap: 0.5rem;
`;

export const PageDot = styled.button`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  border: none;
  background-color: ${props => props.$active ? 'var(--accent-secondary)' : 'var(--border-default)'};
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

